import listActions from 'src/modules/research/list/researchListActions';
import ResearchService from 'src/modules/research/researchService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'RESEARCH_DESTROY';

const researchDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: researchDestroyActions.DESTROY_STARTED,
      });

      await ResearchService.destroyAll([id]);

      dispatch({
        type: researchDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.research.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/research');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: researchDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: researchDestroyActions.DESTROY_ALL_STARTED,
      });

      await ResearchService.destroyAll(ids);

      dispatch({
        type: researchDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.research.destroyAll.success'),
      );

      getHistory().push('/research');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: researchDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default researchDestroyActions;
